import { createContext, useContext } from "react";
import { WebSocketMessage } from "./WebSocketMessage";

export enum ConnectionStatus {
  CONNECTING = "CONNECTING",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  ERROR = "ERROR",
}

// NOTE: Send messages are performed via GraphQL mutations, not WebSocket
export interface WebSocketContextType {
  sendTyping: (chatId: string, typing: boolean) => void;
  sendJoin: (chatId: string) => void;
  sendLeave: (chatId: string) => void;
  onMessage: (handler: (message: WebSocketMessage) => void) => void;
  sendReadReceipt: (chatId: string, messageIds: string[]) => void;

  removeMessageHandler: (handler: (message: WebSocketMessage) => void) => void;
  connectionStatus: ConnectionStatus;
  connect: () => void;
  disconnect: () => void;
}

export const WebSocketContext = createContext<WebSocketContextType | null>(
  null
);

export const useWebSocket = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }
  return context;
};
